import React from 'react';
import Button from 'components/DesignSystem/Button';
import Dialog from 'components/DesignSystem/Dialog';
import DialogBody from 'components/DesignSystem/Dialog/Body';
import DialogFooter from 'components/DesignSystem/Dialog/Footer';

type ErrorDialogProps = {
  open: boolean;
  message: string;
  closing: () => void;
};

export default function ErrorDialog({ open, message, closing }: ErrorDialogProps) {
  return (
    <Dialog open={open} dismiss={closing} type="error" closeButton>
      <DialogBody>
        <p>
          Ocorreu um erro ao salvar a Preferência. Verifique os parâmetros e tente novamente:
        </p>
        <p>
          Erro:
          <b>
            {' '}
            {message}
          </b>
        </p>
      </DialogBody>
      <DialogFooter>
        <Button onClick={closing}>Ok</Button>
      </DialogFooter>
    </Dialog>
  );
}
